import http from "./httpService";

export function getSliders() {
  return http.get("/PublicApi/Sliders").then(({ data }) => data?.data);
}
